<template>
  <div class="footer appcontainer">
    <div class="tabs">
      <a href="/">
        <Button
          color="#00A9B3"
          bgcolor="transparent"
          width="40px"
          height="40"
          padding="0"
          :icon="
            isActive('/') || active == 'home' ? 'home-filled' : 'home-lighter'
          "
        ></Button>
        <span
          :class="
            isActive('/') || active == 'home' ? 'tab-label--active' : undefined
          "
          >{{ $t("general.tab.home") }}</span
        >
      </a>
      <a
        v-if="
        this.$store.getters.user.patient &&
          this.$store.getters.user.role === 'p' &&
            !this.$store.getters.user.patient.isDeceased &&
            !this.$store.getters.user.patient.isArchived
        "
        href="/visit"
      >
        <Button
          color="#00A9B3"
          bgcolor="transparent"
          width="40px"
          height="40"
          padding="0"
          :icon="
            isActive('/visit') || active == 'visit'
              ? 'visit-filled'
              : 'visit-lighter'
          "
        ></Button>
        <span
          :class="
            isActive('/visit') || active == 'visit'
              ? 'tab-label--active'
              : undefined
          "
          >{{ $t("general.tab.visit") }}</span
        >
      </a>
      <a href="/notifications">
        <Badge :value="unreadNotifications.length" />
        <Button
          color="#00A9B3"
          bgcolor="transparent"
          width="40px"
          height="40"
          padding="0"
          :icon="
            isActive('/notifications') || active == 'notifications'
              ? 'bell-filled'
              : 'bell-lighter'
          "
        ></Button>
        <span
          :class="
            isActive('/notifications') || active == 'notifications'
              ? 'tab-label--active'
              : undefined
          "
          >{{ $t("general.tab.notifications") }}</span
        >
      </a>
      <a
        v-if="
        this.$store.getters.user.patient &&
          this.$store.getters.user.role === 'p' &&
            !this.$store.getters.user.patient.isDeceased &&
            !this.$store.getters.user.patient.isArchived &&
            this.$store.getters.user.modules &&
            this.$store.getters.user.modules.webcam
        "
        href="/webcam"
      >
        <Button
          color="#00A9B3"
          bgcolor="transparent"
          width="40px"
          height="40"
          padding="0"
          :icon="
            isActive('/webcam') || active == 'webcam'
              ? 'webcam-filled'
              : 'webcam-lighter'
          "
        ></Button>
        <span
          :class="
            isActive('/webcam') || active == 'webcam'
              ? 'tab-label--active'
              : undefined
          "
          >{{ $t("general.tab.webcam") }}</span
        >
      </a>
      <a href="/menu">
        <Button
          color="#00A9B3"
          bgcolor="transparent"
          width="40px"
          height="40"
          padding="0"
          :icon="
            isActive('/menu') || active == 'menu'
              ? 'menu-filled'
              : 'menu-lighter'
          "
        ></Button>
        <span
          :class="
            isActive('/menu') || active == 'menu'
              ? 'tab-label--active'
              : undefined
          "
          >{{ $t("general.tab.menu") }}</span
        >
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {}
  },
  data: function() {
    return {
      unreadNotifications: this.$store.state.notifications.filter(notif => {
        return !notif.isRead;
      })
    };
  },
  methods: {
    isActive: function(pagePath) {
      if (window.location.pathname == pagePath) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped>
.footer {
  height: 56px;
  width: 100%;
  background-color: #fff;
  bottom: 0;
  position: fixed;
  z-index: 150;
}

.tabs {
  border-top: 1px solid #e57378;
  margin: 0rem 5%;
  display: flex;
  justify-content: space-between;
}

.tabs a {
  width: 25%;
  text-decoration: none;
}

.tabs span {
  font-size: 12px;
  display: block;
  color: #acacac;
  margin-top: -8px;
}

.tab-label--active {
  color: #ef85a7 !important;
}

@media (hover: none) and (pointer: coarse) {
  .footer {
    height: 66px;
  }

  .tabs {
    margin: 0 3%;
  }

  .tabs span {
    font-size: 13px;
    margin-top: -6px;
  }
}
</style>
